<!--
 * @Description: 搜索模板配置
 * @Autor: WangYuan
 * @Date: 2021-06-10 19:31:01
 * @LastEditors: WangYuan
 * @LastEditTime: 2022-02-09 20:29:49
-->
<template>
  <div>
    <!-- 风格主题 -->
    <div class="global-template global-template--simplified" style="padding-right:360px">
      <div style="display: flex;">
        <div class="global-template-left">
          <div>
            <div class="flex row-between">
              <div class="custom-theme-tips">主题配色</div>
              <el-radio-group v-model="form.colourType" size="mini" class="mr15">
                <el-radio-button label="系统配色"></el-radio-button>
                <el-radio-button label="自定义配色"></el-radio-button>
              </el-radio-group>
            </div>
            <div v-if="form.colourType == '系统配色'" class="global-themes">
              <div v-for="item in themeColor" :key="item.id" @click="checkColor(item)" class="theme-item"
                :class="{ active: isColor === item.id }">
                <div class="theme-item-main" :style="item.colorOne"></div>
                <div class="theme-item-main" :style="item.colorTwo"></div>
              </div>
            </div>

            <div v-if="form.colourType == '自定义配色'" class="global-themes">
              <el-form :model="form" ref="form" label-position="left" label-width="150px" style="width: 430px;">
                <el-form-item label="主题色">
                  <div class="flex row-right">
                    <span style="line-height: 40px;">{{ form.theme }}</span>
                    <el-color-picker v-model="form.theme" class="color_div"></el-color-picker>
                    <el-button @click="resetting('theme')" type="text">重置</el-button>
                  </div>
                </el-form-item>
                <el-form-item label="辅助色">
                  <div class="flex row-right">
                    <span style="line-height: 40px;">{{ form.auxiliary }}</span>
                    <el-color-picker v-model="form.auxiliary" class="color_div"></el-color-picker>
                    <el-button @click="resetting('auxiliary')" type="text">重置</el-button>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>

          <!-- <div style="margin-top: 60px;">
            <div class="flex">

              <div class="custom-theme-tips mr16">加载动画</div>
              <div class="animationCon" @mouseenter="showMask = true" @mouseleave="showMask = false">
                <img v-if="currentAnimation" style="width: 76px;height: 76px;padding: 20px 0 0 20px;"
                  :src="currentAnimation" />
                <i v-else class="el-icon-picture-outline" style="font-size: 42px;color: #999;margin: 26px 0 0 28px"></i>
                <div v-if="showMask" class="mask-overlay">
                  <div class="edit-icon" @click="handleEdit">
                    <i class="el-icon-edit"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="animationTips flex" style="align-items: center;">
              页面信息加载缓慢时会显示加载动画
              <el-dropdown>
                <span class="el-dropdown-link ml4 animationexam">
                  查看示例
                </span>
                <el-dropdown-menu slot="dropdown">
                  <div class="animation-dropdown">
                    <div class="dropdown-title">
                      加载示例
                    </div>
                    <div class="dropdownCon">
                      <div class="dropdownItem mr12">
                        <img style="width: 100%;height: 100%;"
                          src="https://cdn.zhaosheng.daheyun1314.com/training/f73e387aa42a457d9cc123a8c5200173.png" />
                        <img v-if="currentAnimation" class="dropdown-loading-icon"
                          style="width: 32px;height: 32px;top:58%" :src="currentAnimation" />
                      </div>
                      <div class="dropdownItem">
                        <img style="width: 100%;height: 100%;"
                          src="https://cdn.zhaosheng.daheyun1314.com/training/96bc4735ba5141ad91290633ef01ce59.png" />
                        <img v-if="currentAnimation" class="dropdown-loading-icon"
                          style="width: 32px;height: 32px;top:81%" :src="currentAnimation" />
                      </div>
                    </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>

            </div>

          </div> -->

        </div>
        <div class="global-template-right">
          <div class="custom-theme-tips">预览效果</div>
          <div class="good-details-preview preview-item-scale">
            <img src="https://img01.yzcdn.cn/upload_files/2023/09/17/FsvXYwMOuFfGXqiD6lTEZEPGeAFH.png!large.webp"
              alt="" />
            <div class="main-price" :style="themeColor[isColor].colorFont">
              <span>￥</span>299-599
              <div class="member-price-tag">会员价</div>
            </div>
            <div class="footer-btn">
              <div class="add-cart-btn" v-if="form.colourType == '系统配色'" :style="themeColor[isColor].colorTwo">加入购物车
              </div>
              <div class="add-cart-btn" v-if="form.colourType == '自定义配色'" :style="{ background: form.auxiliary }">加入购物车
              </div>
              <div class="now-buy-btn" v-if="form.colourType == '系统配色'" :style="themeColor[isColor].colorOne">立即购买</div>
              <div class="now-buy-btn" v-if="form.colourType == '自定义配色'" :style="{ background: form.theme }">立即购买</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 加载动画设置弹窗 -->
    <el-dialog :visible.sync="animationDialogVisible" width="720px" :close-on-click-modal="false"
      custom-class="animation-dialog">
      <template slot="title">
        <div class="animation-dialog-title">
          <span class="animation-dialog-title-bar"></span>
          加载动画设置
        </div>
      </template>
      <div class="animation-dialog-content">
        <div class="animation-dialog-left">
          <div class="flex">
            <div class="animation-style-label">加载动画样式</div>
            <el-radio-group v-model="animationForm.styleType" class="animation-radio-group ml16">
              <el-radio label="系统">系统</el-radio>
              <el-radio label="自定义">自定义</el-radio>
            </el-radio-group>
          </div>
          <div v-if="animationForm.styleType === '系统'" class="animation-grid">
            <div v-for="(item, index) in animationList" :key="index" class="animation-item"
              :class="{ active: selectedIndex === index }" @click="selectAnimation(index)">
              <div class="animation-item-icon" :style="{ backgroundImage: `url(${item.icon})` }"></div>
              <div v-if="selectedIndex === index" class="animation-check-icon"></div>
            </div>
          </div>
          <div v-else class="custom-upload-area">
            <div v-if="!animationForm.customUrl" class="custom-uploader" @click="openCropper">
              <i class="el-icon-plus"></i>
              <span>点击上传</span>
            </div>
            <div v-else class="custom-upload-preview">
              <img :src="customAnimationUrl" />
              <i class="el-icon-delete" @click.stop="removeCustomAnimation"></i>
            </div>
            <div class="custom-upload-tips">建议尺寸:160*160px, 支持.svg格式</div>

          </div>
        </div>

        <div class="animation-dialog-right">
          <img src="https://cdn.zhaosheng.daheyun1314.com/training/f73e387aa42a457d9cc123a8c5200173.png"
            class="animation-preview-img" />
          <img v-if="customAnimationUrl" class="animation-dialog-right-Url" :src="customAnimationUrl" />
          <img v-else class="animation-dialog-right-Url"
            src="https://cdn.zhaosheng.daheyun1314.com/1/animation/858edc7d523548f784b49925a2419803.svg" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="animationDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveAnimation">保存</el-button>
      </span>
    </el-dialog>

    <!-- 图片裁剪弹窗 -->
    <el-dialog title="图片裁剪" :visible.sync="cropperVisible" width="600px" :close-on-click-modal="false" append-to-body>
      <div class="cropper-container">
        <vue-cropper ref="cropper" :img="cropperImg" :output-size="1" :output-type="'png'" :info="true"
          :can-scale="true" :auto-crop="true" :auto-crop-width="160" :auto-crop-height="160" :fixed="true"
          :fixed-number="[1, 1]" :full="true" :fixed-box="true" :can-move="true" :can-move-box="true" :original="false"
          :center-box="true" :max-img-size="3000" :enlarge="1" :mode="'contain'" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cropperVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmCrop">确认裁剪</el-button>
      </span>
    </el-dialog>

    <!-- 隐藏的文件上传input -->
    <input type="file" ref="fileInput" style="display: none" accept=".svg" @change="handleFileChange" />

    <div style="width: 100%;position: fixed;bottom: 0;background: #fff;text-align: center;padding: 10px 0;">
      <el-button @click="reset">取消</el-button>
      <el-button type="primary" @click="saveInfo">保存</el-button>
    </div>
  </div>
</template>

<script>
import { EditInfo } from '@/api/user';
import SearchBar from "@/components/SearchBar";
import { mapGetters } from "vuex";
import global from "@/config/global";
import { VueCropper } from 'vue-cropper';
import { loadingAnimationPage, addLoadingAnimation } from '@/api/easyApp';
export default {
  name: "styleTheme",
  components: {
    VueCropper,
  },
  data() {
    return {
      isColor: "0",
      form: {
        theme: '#FFFFFF',
        auxiliary: '#FFFFFF',
        colourType: '系统配色',
      },
      themeColor: [
        {
          id: "0",
          colorFont: 'color: #ff4444',
          colorOne: 'background-color: #ff4444',
          colorTwo: 'background-color: #ffcccc',
          color: '#ff4444;#ffcccc'
        }, {
          id: "1",
          colorFont: 'color: #ff5e15',
          colorOne: 'background-color: #ff5e15',
          colorTwo: 'background-color: #ff9302',
          color: '#ff5e15;#ff9302'
        }, {
          id: "2",
          colorFont: 'color: #ff547b',
          colorOne: 'background-color: #ff547b',
          colorTwo: 'background-color: #ffe6e9',
          color: '#ff547b;#ffe6e9'
        }, {
          id: "3",
          colorFont: 'color: #ff4444',
          colorOne: 'background-color: #ff4444',
          colorTwo: 'background-color: #555555',
          color: '#ff4444;#555555'
        }, {
          id: "4",
          colorFont: 'color: #fcc600',
          colorOne: 'background-color: #fcc600',
          colorTwo: 'background-color: #1d262e',
          color: '#fcc600;#1d262e'
        }, {
          id: "5",
          colorFont: 'color: #65c4aa',
          colorOne: 'background-color: #65c4aa',
          colorTwo: 'background-color: #d9f7ef',
          color: '#65c4aa;#d9f7ef'
        }, {
          id: "6",
          colorFont: 'color: #63be72',
          colorOne: 'background-color: #63be72',
          colorTwo: 'background-color: #e2f4e3',
          color: '#63be72;#e2f4e3'
        }, {
          id: "7",
          colorFont: 'color: #4a90e2',
          colorOne: 'background-color: #4a90e2',
          colorTwo: 'background-color: #d6eafc',
          color: '#4a90e2;#d6eafc'
        }, {
          id: "8",
          colorFont: 'color: #c3a769',
          colorOne: 'background-color: #c3a769',
          colorTwo: 'background-color: #f3eee1',
          color: '#c3a769;#f3eee1'
        },
      ],
      showMask: false,
      // 加载动画弹窗
      animationDialogVisible: false,
      animationForm: {
        styleType: '系统',
        customUrl: '',
      },
      animationList: [
        { icon: 'https://cdn.zhaosheng.daheyun1314.com/1/animation/858edc7d523548f784b49925a2419803.svg', cdnUrl: '1/animation/858edc7d523548f784b49925a2419803.svg' },
        { icon: 'https://cdn.zhaosheng.daheyun1314.com/1/animation/83f3fe302206469583dfe803719c08a9.svg', cdnUrl: '1/animation/b7655fdc680b4c6b84ed9c22e3418340.svg' },

      ],
      // 裁剪相关
      cropperVisible: false,
      cropperImg: '',
      cropperFile: null,
      selectedIndex: 0,
      currentAnimation: null,
      selectedSystemAnimationUrl: ''
    }
  },

  components: {
    SearchBar,
  },

  computed: {
    ...mapGetters(["project"]),
    customAnimationUrl() {
      if (this.animationForm.styleType === '系统' && this.selectedSystemAnimationUrl) {
        return this.selectedSystemAnimationUrl;
      }
      const url = this.animationForm.customUrl;
      if (!url) return '';
      if (url.startsWith('http')) return url;
      return this.project?.filePath ? this.project.filePath + url : url;
    }
  },
  created() {
    // this.getLoadingAnimation()
    console.log("this.project:", this.project);
    let backgrounds = this.project.configEntity.backgroundColor.split(';');
    console.log("backgrounds:", backgrounds);
    if (backgrounds.length == 2) {
      let index = this.themeColor.findIndex((item) => item.color == this.project.configEntity.backgroundColor);
      if (index != -1) {
        this.isColor = this.themeColor[index].id;
      }
      else {
        this.form.theme = backgrounds[0];
        this.form.auxiliary = backgrounds[1];
      }

    }

  },

  methods: {
    async getLoadingAnimation() {
      let res = await loadingAnimationPage();
      if (res.code == 0 && res.data) {
        let animationUrl = res.data?.animation || ''
        if (animationUrl) {
          this.currentAnimation = animationUrl?.includes('https') ? animationUrl : this.project.filePath + animationUrl
        } else {
          this.currentAnimation = "https://cdn.zhaosheng.daheyun1314.com/1/animation/858edc7d523548f784b49925a2419803.svg"
        }

      }
      console.log('loadingAnimationPage=========this.currentAnimation', this.currentAnimation)
    },
    handleEdit() {
      this.selectedSystemAnimationUrl = ''
      this.selectedIndex = 0
      this.animationDialogVisible = true;
    },
    selectAnimation(index) {
      this.selectedIndex = index;
      this.selectedSystemAnimationUrl = this.animationList[index].icon
      console.log('selectAnimation==========this.selectedSystemAnimationUrl', this.selectedSystemAnimationUrl)
    },
    async saveAnimation() {
      console.log('this.animationForm.customUrl', this.animationForm.customUrl)
      if (this.animationForm.styleType == '自定义' && !this.animationForm.customUrl) {
        this.$message({
          message: "请上传加载动画样式",
          type: "error",
        });
        return
      }
      let animation = ""
      if (this.animationForm.styleType == '系统') {
        animation = this.animationList[this.selectedIndex].icon
      } else {
        animation = this.animationForm.customUrl
      }

      addLoadingAnimation({ animation: animation })
        .then((res) => {
          if (res.code == 0) {
            this.animationDialogVisible = false;
            this.$message({
              message: '加载动画设置已保存',
              type: 'success'
            });
            this.getLoadingAnimation()
          }
        })
        .catch((err) => {
          this.$message({
            message: err.msg,
            type: 'error'
          });
        });

    },
    // 打开文件选择
    openCropper() {
      if (this.animationForm.customUrl) {
        this.removeCustomAnimation();
      }
      this.$refs.fileInput.click();
    },
    // 处理文件选择
    handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) {
        e.target.value = '';
        return;
      }

      // 验证文件类型
      const isSVG = file.type === 'image/svg+xml';
      if (!isSVG) {
        this.$message.error('上传图片只能是 SVG 格式!');
        e.target.value = '';
        return;
      }

      // 验证文件大小
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        e.target.value = '';
        return;
      }

      // SVG 文件直接上传，不裁剪
      if (isSVG) {
        this.uploadCustomAnimation({ file });
        e.target.value = '';
        return;
      }

      // JPG/PNG 需要裁剪
      this.cropperFile = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.cropperImg = e.target.result;
        this.cropperVisible = true;
      };
      reader.readAsDataURL(file);

      e.target.value = '';
    },
    // 确认裁剪并上传
    confirmCrop() {
      this.$refs.cropper.getCropBlob((blob) => {
        const file = new File([blob], this.cropperFile.name, {
          type: blob.type,
          lastModified: Date.now()
        });

        this.uploadCustomAnimation({ file });
        this.cropperVisible = false;
      });
    },
    // 上传文件
    uploadCustomAnimation(item) {
      let file = item.file;
      Vue.prototype.$POST.upload(
        global.baseApi + 'admin/sys-file/upload',
        { file, dir: 'animation' },
        { baseURL: '', timeout: 20000 }
      ).then((res) => {
        if (res.code == 0) {
          this.animationForm.customUrl = res.data.cdnUrl;
          this.$message.success('上传成功');
        } else {
          this.$message.error('上传失败');
        }
      });
    },
    removeCustomAnimation() {
      this.animationForm.customUrl = '';
    },
    checkColor(item) {
      this.isColor = item.id;
      console.log("item:", item);
    },
    add() {
      this.project.configEntity.hotList.push({ value: "" });
    },

    resetting(str) {
      if (str == 'theme') {
        this.form.theme = '#FFFFFF';
      } else {
        this.form.auxiliary = '#FFFFFF';
      }
    },
    saveInfo() {
      let background = null

      if (this.form.colourType == '系统配色') {
        // background =  this.themeColor[this.isColor].colorOne.replace(/\s/g,"").split(':')[1]

        background = this.themeColor[this.isColor].color;

      } else {
        //background = this.form.theme

        let list = this.form.theme + ';' + this.form.auxiliary;
        background = list;

      }
      console.log("this.themeColor[this.isColor]:", this.themeColor[this.isColor]);


      let params1 = { backgroundColor: background, configId: this.project.configEntity.configId }
      this.project.configEntity.backgroundColor = background;

      console.log("this.project:", this.project);


      this.$store.commit('setProject', this.project)


      console.log("this.project:", this.project);

      EditInfo(params1).then(res => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "保存成功!",
          });
        }
      })
    },
    reset() {
      this.isColor = "0"
      this.form = {
        theme: '#FFFFFF',
        auxiliary: '#FFFFFF'
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.global-template {
  width: calc(100% - 30px);
  margin: 10px;
  padding-top: 1px;
  background-color: #ffffff;

  &-left {
    width: 458px;
    margin: 24px 0 0 16px;
    flex-shrink: 0;
  }

  &-right {
    width: 800px;
    flex-grow: 1;
    border-left: 1px solid #e0e0e0;
    padding: 24px 0 0 16px;
    margin-bottom: 60px;
  }

  .custom-theme-tips {
    margin-bottom: 12px;
    max-width: 810px;
    color: #101010;
    font-size: 16px;
    line-height: 20px;
  }

  .global-themes {
    width: 430px;
    margin-left: 0;
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
  }

  .theme-item-main {
    width: 24px;
    height: 24px;
  }

  .theme-item {
    display: flex;
    cursor: pointer;
    margin-bottom: 12px;
    margin-right: 12px;
  }

  .theme-item.active {
    outline: 1px solid #0080f9;
    outline-offset: 2px;
  }

  .preview-item-scale {
    width: 230px;
    margin-right: 8px;
    margin-bottom: 12px;
    position: relative;

    img {
      height: auto;
      max-width: 100%;
      font-size: 100%;
      vertical-align: baseline;
    }

    .main-price {
      position: absolute;
      left: 8px;
      top: 300px;
      display: flex;
      -ms-flex-direction: row;
      flex-direction: row;
      font-size: 12px;
      font-weight: 500;
    }

    .footer-btn {
      display: flex;
      position: absolute;
      top: 385px;
      right: 0;
      font-size: 10px;

      .add-cart-btn {
        width: 70px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        border-top-left-radius: 18px;
        border-bottom-left-radius: 18px;
      }

      .now-buy-btn {
        width: 70px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        border-top-right-radius: 18px;
        border-bottom-right-radius: 18px;
      }
    }
  }

  .el-form-item__label {
    color: #a8a6a6;
  }

  .color_div {
    width: 60px;
    margin-left: 16px;
    margin-right: 20px;
  }

}

.global-template-title {
  margin: 16px;
  line-height: 26px;
  font-size: 20px;
  font-weight: 500;
}

.nav-item {
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 2px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.animationCon {
  position: relative;
  width: 96px;
  height: 96px;
  background-color: #f5f5f5;
  border-radius: 12px;
  cursor: pointer;
}

/* 蒙版样式 */
.mask-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: all 0.3s ease;
}

/* 修改图标样式 */
.edit-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: white;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.animationTips {
  margin-left: 78px;
  margin-top: 10px;
  color: #999;
  font-size: 12px;
}

.edit-icon i {
  font-size: 24px;
}

.mr16 {
  margin-right: 16px;
}

.ml4 {
  margin-left: 4px;
}

.animationexam {
  color: #3e69f7;
  font-size: 12px;
  cursor: pointer;
}

.animation-dropdown {
  padding: 16px;
}

.dropdown-title {
  font-size: 14px;
  color: #101010;
  font-weight: 600;
}

.dropdownCon {
  margin-top: 12px;
  display: flex;
  padding: 12px;
  width: 300px;
  height: 100%;
  border-radius: 8px;
  background-color: #f7f8fa;
}

.dropdownItem {
  position: relative;
  width: 50%;
  height: 312px;

  >img:first-child {
    position: absolute;
    top: 20px;
    border-radius: 4px;
  }
}

.dropdown-loading-icon {
  position: absolute;
  left: 51%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

/* 加载动画弹窗样式 */
.animation-dialog-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.animation-dialog-title-bar {
  width: 4px;
  height: 16px;
  background-color: #409eff;
  border-radius: 2px;
  margin-right: 8px;
}

.animation-dialog-content {
  display: flex;
  gap: 24px;
}

.animation-dialog-left {
  flex-shrink: 0;
  width: 380px;
}

.animation-dialog-right {
  position: relative;
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 8px;
}

.animation-dialog-right-Url {
  position: absolute;
  top: 48%;
  left: 50%;
  transform: translateX(-50%);
  width: 48px;
  height: 48px;
  z-index: 99;
  object-fit: contain;
}

.animation-preview-img {
  width: 240px;
  border-radius: 12px;
  border: 1px solid #eee;
}

.animation-style-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 12px;
}

.animation-radio-group {
  margin-bottom: 16px;
}

.animation-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.animation-item {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  cursor: pointer;
  position: relative;
  background-color: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &.active {
    border: 2px solid #409eff;
    background-color: #fff;
  }
}

.animation-item-icon {
  width: 48px;
  height: 48px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.animation-check-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 22px;
  height: 22px;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #409eff;
    clip-path: polygon(100% 0, 100% 100%, 0 100%);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 4px;
    right: 3px;
    width: 8px;
    height: 4px;
    border-left: 1.5px solid #fff;
    border-bottom: 1.5px solid #fff;
    transform: rotate(-45deg);
  }
}

/* 自定义上传区域 */
.custom-upload-area {
  margin-top: 16px;
  margin-left: 100px;
}

.custom-uploader {
  width: 120px;
  height: 120px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
  transition: all 0.2s ease;

  &:hover {
    border-color: #409eff;
    color: #409eff;
  }

  i {
    font-size: 20px;
    margin-bottom: 4px;
  }

  span {
    font-size: 12px;
  }
}

.custom-upload-tips {
  margin-top: 12px;
  font-size: 12px;
  color: #999;
}

.custom-upload-preview {
  margin-top: 12px;
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e8e8e8;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
    color: #fff;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 2;
  }

  &:hover {
    i {
      opacity: 1;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1;
    }
  }
}

/* 裁剪弹窗样式 */
.cropper-container {
  width: 100%;
  height: 400px;
}
</style>
